<script>
import { Bar } from 'vue-chartjs';
export default {
    extends: Bar,
    props: {
        labels: {
            type: Array,
            default: () => ({})
        },
        options: {
            type: Object,
            default: () => ({})
        },
        data: {
            type: Object,
            default: () => ({})
        }
    },
    mounted () {
        this.render();
    },
    methods: {
        render() {
            this.renderChart(this.data, this.options)
        }
    },
    computed: {
        datasetsState() {
            return this.data;
        }
    },
    watch: {
        data(updatedData) {
            this.render();
        }
    }
}
</script>
